(() => {
  const { apiBase } = window.swinger.config;
  const protectedKeys = [
    'alternateLinks',
  ];

  const recursiveLanguageResolve = (item) => {
    if (item === undefined) {
      return undefined;
    }

    const language = window.swinger.config.language;

    const reviver = (key, value) => {
      if (
        protectedKeys.indexOf(key) === -1
        && value
        && value[language] !== undefined
      ) {
        return value[language];
      }

      return value;
    };

    return JSON.parse(JSON.stringify(item), reviver);
  };

  const api = {
    me() {
      const url = new URL(window.location);
      const search = decodeURIComponent(url.search).slice(1);

      return window.swinger.ajax(`${apiBase}${window.swinger.config.apiRoutes.me}?${search}`);
    },
    getPromotions() {
      return window.swinger.ajax(`${apiBase}${window.swinger.config.apiRoutes.promotions}`)
        .then(recursiveLanguageResolve);
    },
    getFeedUrls() {
      if (!window.swinger.user.isLoggedIn()) {
        return Promise.resolve({});
      }

      return window.swinger.ajax(`${apiBase}${window.swinger.config.apiRoutes.feedInit}`)
        .catch(() => ({}));
    },
    getItemDetails(itemnumber) {
      let baseUrl = `${window.swinger.config.apiRoutes.contentMovies}`;

      switch (true) {
        default:
          break;

        case itemnumber.indexOf('AMA') === 0:
          baseUrl = `${window.swinger.config.apiRoutes.contentClips}`;
          break;

        case itemnumber.indexOf('-') > -1:
          baseUrl = `${window.swinger.config.apiRoutes.contentScenes}`;
          break;
      }
      const itemUrl = `${apiBase}${baseUrl}?idList[]=${encodeURIComponent(itemnumber)}`;

      return window.swinger.ajax(itemUrl);
    },
    getItemSources(itemnumber) {
      return window.swinger.ajax(`${apiBase}${window.swinger.config.apiRoutes.streamingSources}?itemNumber=${itemnumber}`);
    },
  };

  window.swinger = { ...window.swinger, api };
})();
